module.exports = __webpack_public_path__ + "img/swab3_7-8-2021.61120a8f.jpg";